import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {mobilePhoneNumberValidator, mustMatch, pwdValidator} from "../../utils/form-validators";
import {User} from "../../models/user.model";
import {CommonUtils} from "../../utils/common";
import {UserService} from "../../providers/user.service";
import {ModalController, ToastController} from "@ionic/angular";
import {Subscription} from "rxjs";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {VetClinicStartContextData} from "../../models/vet-clinic-start-context-data.model";
import {ClientsService} from "../../providers/clients.service";
import {Client} from "../../models/client.model";
import {AppStateService} from "../../providers/app-state.service";
import {VetClinic} from "../../models/vet-clinic.model";
import {PartnerService} from "../../providers/partner.service";
import {Partner} from "../../models/partner.model";
import {ItemFinderComponent} from "../item-finder/item-finder.component";


@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent implements OnInit, OnDestroy {

  @Input() csrfToken: string;
  @Input() isUserToAddPartnerType: boolean;
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();

  userGroup: FormGroup;
  private vetClinicStartContextSub: Subscription;
  private vetClinicStartContext: VetClinicStartContextData;
  private hasUnsavedChanges = false;
  private clientsSub: Subscription;
  private clientSub: Subscription;
  clients: Client[];
  sendEmail: boolean;
  private user: User;
  private isPartnerType: boolean;
  isGeneralAdmin: boolean;
  roles: string[];
  private clinics: VetClinic[];
  clientSelected: Client;

  @Output() userAddedEmitter = new EventEmitter<User>();
  @Output() userAddCanceledEmitter = new EventEmitter<Boolean>();
  private loggedUser: User;
  private isAdmin: boolean;
  isClientAdmin: boolean = false;
  pwdType: string = 'password';
  showPwdIcon: string = 'eye-off-outline';
  pwdSub: Subscription;
  isPartnerAdmin: boolean;
  partnerBannerActions: boolean;
  private clinicsSub: Subscription;
  isArticleModeEnabled: boolean;
  clinicSelected: VetClinic;
  isGeneralUserAdmin: boolean;
  recommendationSystem: boolean;
  canAddWellnessPlanRoles: boolean = false;
  checkCarePlanSub: Subscription;


  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastController: ToastController,
    private clientService: ClientsService,
    private vetClinicService: VetClinicService,
    private appStateService: AppStateService,
    private partnerService: PartnerService,
    private modalController: ModalController
  ) {
  }

  ngOnInit() {
    this.appStateService.updateIsBusySubject(true);
    this.roles = [];
    this.isPartnerType = false;
    this.isGeneralAdmin = false;
    this.userService.getUser().subscribe(it => {
      console.log('this is user', it)
        this.loggedUser = this.commonUtils.bestTypedCopyEver<User>(new User(), it);
        this.isAdmin = this.loggedUser.roles.split(';').filter(e => e === 'admin').length === 1;
        this.isGeneralUserAdmin = this.loggedUser.roles.split(';').filter(e => e === 'users').length === 1  && this.loggedUser.vClientId === null && this.loggedUser.vetcodeId === null;
        this.isGeneralAdmin = this.isAdmin && this.loggedUser.vClientId === null && this.loggedUser.vetcodeId === null;
        this.isClientAdmin = this.isAdmin && this.loggedUser.vClientId !== null && this.loggedUser.vetcodeId === null && !it.isPartnerType;
        this.isPartnerAdmin = this.isAdmin && this.loggedUser.vClientId !== null && this.loggedUser.vetcodeId === null && it.isPartnerType;

        this.checkCarePlanSub = this.userService.checkCarePlanEnabled().subscribe(e=> {
          if (e) {
            this.canAddWellnessPlanRoles = true;
            this.handleRoles();
          }
        });

        if (this.isClientAdmin) {
          console.log('this is client admin')
          this.clientSub = this.clientService.getClientByUUID(it.vClientUUID).subscribe(e=>{
            if(e){
              console.log('this is e ')
              this.clientSelected = e;
              this.onChooseClient(it.vClientUUID)
              this.handleRoles();
            }
          })

          this.onChooseClient(this.loggedUser.vClientUUID)
        }
      if (this.isPartnerAdmin) {
        this.clientSub = this.clientService.getClientByUUID(it.vClientUUID).subscribe(e=>{
          if(e){
            if(e.partnerBannerActions){
              this.partnerBannerActions = e.partnerBannerActions
              this.handleRoles();
            }
            if(e.isArticleModeEnabled){
              this.isArticleModeEnabled = e.isArticleModeEnabled
              this.handleRoles();
            }

            this.clientSelected = e;
            this.onChooseClient(it.vClientUUID)
          }
        })

        this.onChooseClient(this.loggedUser.vClientUUID)
      }
      }
    );

    this.vetClinicStartContextSub = this.vetClinicService.getVetClinicStartContextData().subscribe((vetClinicStartContext) => {
      this.vetClinicStartContext = vetClinicStartContext;
    });
    this.handleRoles();

    if (!this.isUserToAddPartnerType) {
      this.clientsSub = this.clientService.listAllClients().subscribe(vClients => {
          if (this.loggedUser !== null) {
            if (this.loggedUser.vClientId) {
              this.clients = vClients.filter(e => e.id?.toString() == this.loggedUser.vClientId);
            } else {
              this.clients = vClients;
            }
          } else {
            this.clients = vClients;
          }
        }
      );
    } else {
      if (this.isGeneralAdmin  || this.isGeneralUserAdmin) {
        this.clientsSub = this.clientService.listAllPartners().subscribe(vClients => {
            if (this.loggedUser !== null) {
              if (this.loggedUser.vClientId) {
                this.clients = vClients.filter(e => e.id?.toString() == this.loggedUser.vClientId);
              } else {
                this.clients = vClients;
              }
            } else {
              this.clients = vClients;
            }
          }
        );
      }


    }
    this.sendEmail = false;
    if (this.isGeneralAdmin || this.isGeneralUserAdmin) {
      this.userGroup = this.formBuilder.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        mobilePhone: ['', [Validators.required, mobilePhoneNumberValidator]],
        email: ['', Validators.email],
        password: ['', [Validators.required,pwdValidator]],
        retypePassword: ['', Validators.required],
        rolesTab: ['', [Validators.required]],
        vClientId: ['', Validators.required],
        vetcodeId: ['']
      }, {validators: mustMatch('password', 'retypePassword')});
    } else {
      if (this.isClientAdmin) {
        this.userGroup = this.formBuilder.group({
          firstName: ['', Validators.required],
          lastName: ['', Validators.required],
          mobilePhone: ['', [Validators.required, mobilePhoneNumberValidator]],
          email: ['', Validators.email],
          rolesTab: ['', Validators.required],
          vetcodeId: [''],
          password: ['',[Validators.required, pwdValidator]],
          retypePassword: ['', Validators.required]
        }, {validators: mustMatch('password', 'retypePassword')},);
      } else {
        this.userGroup = this.formBuilder.group({
          firstName: ['', Validators.required],
          lastName: ['', Validators.required],
          mobilePhone: ['', [Validators.required, mobilePhoneNumberValidator]],
          email: ['', Validators.email],
          rolesTab: ['', Validators.required],
          password: ['',[Validators.required, pwdValidator]],
          retypePassword: ['', Validators.required]
        }, {validators: mustMatch('password', 'retypePassword')});
      }
    }
    this.appStateService.updateIsBusySubject(false);
  }

  onAdd() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz dodać nowego użytkownika?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      if(this.clinicSelected) {
        this.userGroup.controls.vetcodeId.setValue(this.clinicSelected.vetcodeId);
      }
      const userAdded: User = this.commonUtils.formGroupValuesToObject<User>(new User(), this.userGroup);
      userAdded.roles = this.userGroup.get('rolesTab').value?.join(';');

      if (this.loggedUser.vClientId) {
        userAdded.vClientId = this.loggedUser.vClientId;
        if (!this.isClientAdmin) {
          userAdded.vetcodeId = this.loggedUser.vetcodeId;
        }
      }
      // todo tworząc partnera pomimo ustwienia isPartnerType w momencie pozniejszego edytowania isPartnerType ustawia się na false
      if(this.isUserToAddPartnerType !== null) {
        userAdded.isPartnerType = this.isUserToAddPartnerType;
      }
      console.log(userAdded);
      this.userService.addUser(userAdded, this.sendEmail)
        .subscribe((user: User) => {
            if (user && user.uuid) {
              this.commonUtils.presentInfoToast("Użytkownik został zarejestrowany").then(res => {
                this.userAddedEmitter.emit(user);
              });
            } else {
              this.commonUtils.presentAlertToast("Wystąpił błąd podczas dodawania użytkownika");
            }
          },
          error => {
            let errorMsg = error.error?.errors?.main;
            if (errorMsg) {
              if (errorMsg === 'USER_NOT_FOUND') {
                this.commonUtils.presentAlertToast('Brak zalogowanego użytkownika');
              }
              if (errorMsg === 'EMPTY_ROLES') {
                this.commonUtils.presentAlertToast('Brak ról użytkownika');
              }
              if (errorMsg === 'INVALID_ROLES') {
                this.commonUtils.presentAlertToast('Błędne role użytkownika');
              }
              if (errorMsg === 'USER_UNAUTHORIZED') {
                this.commonUtils.presentAlertToast('Nie masz uprawnień');
              }
              if (errorMsg === 'BAD_VCLIENT') {
                this.commonUtils.presentAlertToast('Klient nie isnieje');
              }
              if (errorMsg === 'EMAIL_ALREADY_EXIST') {
                this.commonUtils.presentAlertToast('Użytkownik o podanym adresie email istnieje');
              }
              if (errorMsg === 'PHONE_ALREADY_EXIST') {
                this.commonUtils.presentAlertToast('Użytkownik o podanym nr. telefonu istnieje');
              }
              if (errorMsg === 'EXCEPTION_DURING_ADDING') {
                this.commonUtils.presentAlertToast('Wystąpił błąd podczas dodawania');
              }
            } else {
              this.commonUtils.presentAlertToast('Wystąpił niespodziewany błąd');
            }
          });
    }, () => {
    });
  }

  onCancelAdd() {
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany. Na pewno chcesz zrezygnować z dodania użytkownika?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.userAddCanceledEmitter.emit(true);
      }, () => {
      });
    } else {
      this.userAddCanceledEmitter.emit(true);
    }
  }

  isFormFieldInvalid(form: FormGroup, fieldName: string, validationType: string) {
    return this.commonUtils.isFormFieldInvalid(form, fieldName, validationType);
  }

  isFormInvalid(form: FormGroup, validationType: string) {
    return this.commonUtils.isFormInvalid(form, validationType);
  }

  ngOnDestroy(): void {
    if (this.vetClinicStartContextSub) this.vetClinicStartContextSub.unsubscribe();
    if (this.clientsSub) this.clientsSub.unsubscribe();
    if (this.pwdSub) this.pwdSub.unsubscribe();
    if (this.clientSub) this.clientSub.unsubscribe();
    if (this.clinicsSub) this.clinicsSub.unsubscribe();
    if (this.checkCarePlanSub) this.checkCarePlanSub.unsubscribe();
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
      this.hasUnsavedChangesEmitter.emit(true);
    }
  }

  selectClient($event) {
    this.clientSelected = this.clients.filter(e => e.id == $event.detail.value)[0];
    this.onChooseClient(this.clientSelected.uuid);
    this.markUnsavedChanges();
  }

  onChooseClient(vClientUUID: string) {
    console.log('onChooseClient')
    if(this.isUserToAddPartnerType){
     this.partnerBannerActions = (this.clientSelected as Partner).partnerBannerActions;
     this.isArticleModeEnabled = (this.clientSelected as Partner).isArticleModeEnabled;
      this.handleRoles();
    } else {
      this.appStateService.updateIsBusySubject(true);
      this.clinicsSub = this.vetClinicService.listClinicsForClient(vClientUUID).subscribe(e => {
        if (e) {
          this.appStateService.updateIsBusySubject(false);
          this.clinics = e;
          if (this.clinics.length === 1) {
            this.clinicSelected = this.clinics[0];
            this.recommendationSystem = this.clinicSelected.pragmaticBoxCode != null;
            this.handleRoles();
            this.userGroup.controls.vetcodeId.markAsTouched();
          } else {
            this.handleRoles();
          }
        } else {
          this.appStateService.updateIsBusySubject(false);
          this.commonUtils.presentAlertToast('Nie znaleziono lecznic dla podanego klienta');
        }
      });
    }

  }

  onChangePwdType() {
    if(this.pwdType === 'password'){
      this.pwdType = 'text';
      this.showPwdIcon = 'eye-outline';
    } else {
      this.pwdType = 'password';
      this.showPwdIcon = 'eye-off-outline';
    }
  }

  generatePwd() {
    this.appStateService.updateIsBusySubject(true);
    this.pwdSub = this.userService.generatePwd().subscribe(pwd=>{
      if(pwd){
        this.pwdType = 'text';
        this.showPwdIcon = 'eye-outline';
        this.userGroup.controls.password.markAsTouched();
        this.userGroup.controls.password.setValue(pwd);
        this.userGroup.controls.retypePassword.setValue(pwd);
        this.commonUtils.presentInfoToast('Twoje hasło zostgało wygenerowane');
      } else {
        this.commonUtils.presentAlertToast('Wystąpił błąd');
      }
      this.appStateService.updateIsBusySubject(false);
    }, error => {
      this.commonUtils.presentAlertToast('Wystąpił błąd');
      this.appStateService.updateIsBusySubject(false);
    });

  }

  private handleRoles() {
    this.roles = [];
    if (this.isUserToAddPartnerType) {
      this.roles.push('sales');
      if(this.isAdmin || this.isGeneralAdmin){
        this.roles.push('sales-manager');
      }
      if(this.partnerBannerActions){
        this.roles.push('partner-banner-actions');
      }

      if(this.isArticleModeEnabled){
        if(this.isAdmin){
          this.roles.push('articles-redactor');
        }
        this.roles.push('articles');
      }

    } else {

      if (this.canAddWellnessPlanRoles) {
        this.roles.push('wellness-plans');
      }

      this.roles.push('users');
      this.roles.push('vet-reservations');
      this.roles.push('orders');
      this.roles.push('v-messages');
      this.roles.push('prepaid');
      this.roles.push('payments-refund');
      this.roles.push('lab-test-data');
      if (this.recommendationSystem) {
        this.roles.push('product-recommendations');
      }

      if (this.isGeneralAdmin && this.clientSelected?.id === 177) {
        this.roles.push('call-center');
      }

    }
    if (this.isGeneralAdmin || this.isGeneralUserAdmin) {
      this.roles.push('admin');
      if(!this.isUserToAddPartnerType){
        this.roles.push('clients');
      }
    }


    if (this.isAdmin && this.clientSelected && this.clientSelected.partnerUUID) {
      this.roles.push('referrals');
    }
    console.log(this.roles);
  }

  async onSearchClients() {
    const modal = await this.modalController.create({
      component: ItemFinderComponent,
      componentProps: {
        title: 'Wyszukaj klienta',
        itemType: 'clients',
        nameToFind: this.clientSelected ? this.clientSelected.name : '',
        partnersIncluded: this.isUserToAddPartnerType
      }
    });

    modal.onWillDismiss().then(data => {
      if (data && data.data) {
        this.clinicSelected = null;
        this.clientSelected = data.data;
        this.userGroup.controls.vClientId.setValue(this.clientSelected.id);
        this.onChooseClient(this.clientSelected.uuid);
      }
    });

    return await modal.present();
  }

  selectClinic($event) {
    this.clinicSelected = $event.detail.value;
    this.recommendationSystem = this.clinicSelected.pragmaticBoxCode != null;
    this.handleRoles();
    this.userGroup.controls.vetcodeId.markAsTouched();
  }

  canSelectNotApplicable() {
    if(this.isGeneralAdmin || this.isGeneralUserAdmin) {
      return true;
    }
    return this.isAdmin && (this.loggedUser.vetcodeId === null || this.loggedUser.vetcodeId === undefined);

  }
}
